function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var Tweet = require('./tweet');
function addTweet(mod, tx) {
  var tweet = new Tweet(mod.app, mod, tx);
  if (!tweet.signature) {
    return null;
  }
  if (!isValidTweetMessage(mod, tweet)) {
    return null;
  }
  if (mod.app.modules.moderate(tx, mod.name) === -1) {
    return null;
  }
  if (hasTweet(mod, tweet.signature)) {
    return updateTweet(mod, tx);
  }
  mod.tweets[tweet.signature] = tweet;
  indexTweetRelationships(mod, tweet.signature);
  insertTimeline(mod, tweet.signature);
  attachOrphans(mod, tweet.signature);
  return tweet;
}
function removeTweet(mod, signature) {
  if (!signature || !hasTweet(mod, signature)) {
    return false;
  }
  unindexTweetRelationships(mod, signature);
  removeFromTimeline(mod, signature);
  delete mod.tweets[signature];
  return true;
}
function updateTweet(mod, tx) {
  var tweet = new Tweet(mod.app, mod, tx);
  if (!tweet.signature) {
    return null;
  }
  if (!isValidTweetMessage(mod, tweet)) {
    return null;
  }
  var existing = getTweet(mod, tweet.signature);
  if (!existing) {
    return addTweet(mod, tx);
  }
  var previousParent = existing.parent_id || '';
  existing.updateFromTransaction(tx);
  if ((existing.parent_id || '') !== previousParent) {
    unindexTweetRelationships(mod, tweet.signature);
    indexTweetRelationships(mod, tweet.signature);
    removeFromTimeline(mod, tweet.signature);
    insertTimeline(mod, tweet.signature);
  } else {
    resortTimeline(mod);
  }
  return existing;
}
function getTweet(mod, signature) {
  if (!signature) {
    return null;
  }
  return mod.tweets[signature] || null;
}
function hasTweet(mod, signature) {
  return Boolean(signature && mod.tweets[signature]);
}
function isValidTweetMessage(mod, tweet) {
  var tx = tweet.tx;
  var txmsg = tx && typeof tx.returnMessage === 'function' ? tx.returnMessage() : tx !== null && tx !== void 0 && tx.msg && _typeof(tx.msg) === 'object' ? tx.msg : {};
  if (txmsg.module && txmsg.module !== mod.name) {
    return false;
  }
  if (txmsg.request && txmsg.request !== 'create tweet') {
    return false;
  }
  return true;
}
function indexTweetRelationships(mod, signature) {
  var tweet = getTweet(mod, signature);
  if (!tweet || !tweet.parent_id) {
    return;
  }
  var parentId = tweet.parent_id;
  mod.tweets_parents[signature] = parentId;
  if (hasTweet(mod, parentId)) {
    addChildSignature(mod, parentId, signature);
    return;
  }
  if (!mod.tweets_orphans[parentId]) {
    mod.tweets_orphans[parentId] = [];
  }
  if (!mod.tweets_orphans[parentId].includes(signature)) {
    mod.tweets_orphans[parentId].push(signature);
  }
}
function unindexTweetRelationships(mod, signature) {
  var parentId = mod.tweets_parents[signature];
  if (parentId) {
    removeChildSignature(mod, parentId, signature);
    delete mod.tweets_parents[signature];
  }
  if (mod.tweets_children[signature]) {
    var _iterator = _createForOfIteratorHelper(mod.tweets_children[signature]),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var childSignature = _step.value;
        delete mod.tweets_parents[childSignature];
        if (!mod.tweets_orphans[signature]) {
          mod.tweets_orphans[signature] = [];
        }
        if (!mod.tweets_orphans[signature].includes(childSignature)) {
          mod.tweets_orphans[signature].push(childSignature);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    delete mod.tweets_children[signature];
  }
  for (var _i = 0, _Object$keys = Object.keys(mod.tweets_orphans); _i < _Object$keys.length; _i++) {
    var parentKey = _Object$keys[_i];
    mod.tweets_orphans[parentKey] = mod.tweets_orphans[parentKey].filter(function (s) {
      return s !== signature;
    });
    if (mod.tweets_orphans[parentKey].length === 0) {
      delete mod.tweets_orphans[parentKey];
    }
  }
}
function addChildSignature(mod, parentSignature, childSignature) {
  if (!mod.tweets_children[parentSignature]) {
    mod.tweets_children[parentSignature] = [];
  }
  if (!mod.tweets_children[parentSignature].includes(childSignature)) {
    mod.tweets_children[parentSignature].push(childSignature);
  }
  updateCriticalChild(mod, parentSignature);
}
function removeChildSignature(mod, parentSignature, childSignature) {
  var children = mod.tweets_children[parentSignature];
  if (!children) {
    return;
  }
  mod.tweets_children[parentSignature] = children.filter(function (s) {
    return s !== childSignature;
  });
  if (mod.tweets_children[parentSignature].length === 0) {
    delete mod.tweets_children[parentSignature];
  }
  updateCriticalChild(mod, parentSignature);
}
function updateCriticalChild(mod, parentSignature) {
  var parent = getTweet(mod, parentSignature);
  if (!parent) {
    return;
  }
  var children = mod.tweets_children[parentSignature] || [];
  if (children.length === 0) {
    parent.critical_child = null;
    return;
  }
  var selected = null;
  var selectedAt = -1;
  var _iterator2 = _createForOfIteratorHelper(children),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var childSignature = _step2.value;
      var child = getTweet(mod, childSignature);
      if (!child) {
        continue;
      }
      if (child.created_at >= selectedAt) {
        selectedAt = child.created_at;
        selected = childSignature;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  parent.critical_child = selected;
}
function attachOrphans(mod, parentSignature) {
  var orphans = mod.tweets_orphans[parentSignature];
  if (!orphans || orphans.length === 0) {
    return;
  }
  var _iterator3 = _createForOfIteratorHelper(orphans),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var childSignature = _step3.value;
      mod.tweets_parents[childSignature] = parentSignature;
      addChildSignature(mod, parentSignature, childSignature);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  delete mod.tweets_orphans[parentSignature];
}
function insertTimeline(mod, signature) {
  var tweet = getTweet(mod, signature);
  if (!tweet || tweet.parent_id || tweet.ephemeral) {
    return;
  }
  if (!mod.tweets_timeline.includes(signature)) {
    mod.tweets_timeline.push(signature);
  }
  resortTimeline(mod);
}
function removeFromTimeline(mod, signature) {
  mod.tweets_timeline = mod.tweets_timeline.filter(function (s) {
    return s !== signature;
  });
}
function resortTimeline(mod) {
  mod.tweets_timeline.sort(function (a, b) {
    var tweetA = getTweet(mod, a);
    var tweetB = getTweet(mod, b);
    return ((tweetB === null || tweetB === void 0 ? void 0 : tweetB.created_at) || 0) - ((tweetA === null || tweetA === void 0 ? void 0 : tweetA.created_at) || 0);
  });
}
function showTweetInfo(mod, tweet) {
  if (!tweet) {
    return;
  }
  var lines = ["Tweet signature: ".concat(tweet.signature), "Author: ".concat(tweet.username), "Public key: ".concat(tweet.publicKey || 'unknown'), "Posted: ".concat(new Date(tweet.created_at).toLocaleString())];
  if (tweet.thread_id) {
    lines.push("Thread: ".concat(tweet.thread_id));
  }
  if (tweet.parent_id) {
    lines.push("Parent: ".concat(tweet.parent_id));
  }
  alert(lines.join('\n'));
}
module.exports = {
  addTweet: addTweet,
  removeTweet: removeTweet,
  updateTweet: updateTweet,
  getTweet: getTweet,
  hasTweet: hasTweet,
  isValidTweetMessage: isValidTweetMessage,
  indexTweetRelationships: indexTweetRelationships,
  unindexTweetRelationships: unindexTweetRelationships,
  addChildSignature: addChildSignature,
  removeChildSignature: removeChildSignature,
  updateCriticalChild: updateCriticalChild,
  attachOrphans: attachOrphans,
  insertTimeline: insertTimeline,
  removeFromTimeline: removeFromTimeline,
  resortTimeline: resortTimeline,
  showTweetInfo: showTweetInfo
};